import { useEffect, useState } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { setLenis } from "@/lib/scroll";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import ServicesManifesto from "@/components/ServicesManifesto";
import RevenueSimulator from "@/components/RevenueSimulator";
import Testimonials from "@/components/Testimonials";
import ContactForm from "@/components/ContactForm";
import Footer from "@/components/Footer";
import LiveChatWidget from "@/components/LiveChatWidget";
import AboutPage from "@/pages/AboutPage";
import { BrowserRouter, Routes, Route } from "react-router-dom";

function Landing() {
    const [prefill, setPrefill] = useState("");

    useEffect(() => {
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        setLenis(lenis);
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        if (window.location.hash) {
            setTimeout(() => {
                const el = document.querySelector(window.location.hash);
                if (el) lenis.scrollTo(el, { offset: -72, duration: 1.2 });
            }, 700);
        }
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            setLenis(null);
        };
    }, []);

    return (
        <div className="min-h-screen bg-[#FAF8F5] text-[#2B2622] antialiased overflow-x-clip">
            <div className="noise-overlay" />
            <Navbar />
            <main>
                <Hero />
                <Marquee />
                <ServicesManifesto />
                <RevenueSimulator onEstimate={setPrefill} />
                <Testimonials />
                <ContactForm prefill={prefill} />
            </main>
            <Footer />
            <LiveChatWidget />
            <Toaster position="top-center" theme="light" richColors />
        </div>
    );
}

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/a-propos" element={<AboutPage />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
